import { Grid, TextField, Typography, Button, Link } from '@mui/material'
import colors from '../../../../colors';
import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { sendGeneralRequest } from '../../../../../features/generalRequest'
import { selectAlbtelecomMobileState, changeConfirmationDialogState, setPhone, resetAlbTelecomMobileSlice, setIsTransactionSuccessfullyStarted, setIsTransactionSuccessfullyCompleted } from '../../../../../features/albtelecomMobile/albtelecomMobileSlice'
import { ConfirmationDialog } from '../../../../general/ConfirmationDialog'
import { makeStyles } from '@mui/styles';
import { selectUserInfo } from '../../../../../features/userInfo/userInfoSlice';
import { selectBasicAccountState, setShouldBasicAccountPaymentRun, setTransactionIdToCancel } from '../../../../../features/basicAccount/basicAccountSlice';
import { runBasicAccountPayment } from '../../../../general/BasicAccountMethods';
import { setGeneralMessage } from '../../../../../features/global/globalDataSlice';
import { selectMyContractsState, setShouldFillFields } from '../../../../../features/myContracts/myContractsSlice';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import { texts } from '../../../../general/texts';
import { selectUtilityState } from '../../../../../features/utilities/utilitySlice';

export const AlbtelecomMobile = (props) => {

    const albtelecomMobileSliceState = useSelector(selectAlbtelecomMobileState)
    const dispatch = useDispatch()
    const userInfo = useSelector(selectUserInfo)
    const basicAccountSliceState = useSelector(selectBasicAccountState)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const utilitySliceState = useSelector(selectUtilityState)
    const navigate = useNavigate()

    const [state, setState] = React.useState({
        token: props.globalDataSliceState.token,
        phone: '',
        value: ''
    })

    const handleTextFieldChange = (prop) => (e) => 
    {
        setState({
            ...state,
            [prop]: e.target.value
        })
    }

    const handleSearchButtonClick = () => 
    {
        if(state.phone === '' || !new RegExp('^[0-9]+$').test(state.value))
        {   
            dispatch(setGeneralMessage({type: 'error', message: texts["message-complete-fields"]}))
        }
        else
        {
            dispatch(changeConfirmationDialogState())
        } 
    }
    
    const startTransaction = () => 
    {
        dispatch(setPhone(state.phone))
        dispatch(sendGeneralRequest({request: {...state, value: parseInt(state.value)}, baseUrlKey:'services', endpoint:'Eagle/StartTransaction'}))
        dispatch(changeConfirmationDialogState())
    }

    const handleBackButton = () => 
    {
        dispatch(setShouldBasicAccountPaymentRun(false))
        dispatch(resetAlbTelecomMobileSlice())
    }

    React.useEffect(()=>{
        if(myContractsSliceState.shouldFillFields)
        {
            setState({
                ...state,
                phone: props.selectedContractInfo.contract
            })
            dispatch(setShouldFillFields(false))
        }
    },[myContractsSliceState.shouldFillFields])

    React.useEffect(()=>{
        if(props.albtelecomMobileSliceState.isTransactionSuccessfullyStarted){

            if(userInfo.accountType === 3)
            {
                dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token,applicationID:1, paymentMethod:'2', value: Number(state.value), transID: props.albtelecomMobileSliceState.transactionId}, baseUrlKey:'services', endpoint:'startCreditCardPayment'}))
                dispatch(setTransactionIdToCancel(props.albtelecomMobileSliceState.transactionId))
            }
            else
            {
                dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, transID: props.albtelecomMobileSliceState.transactionId, service: props.utilityName, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true}, baseUrlKey:'services', endpoint:'Eagle/ConfirmTransaction'}))
            }
            // userInfo.accountType === 3
            //     ? dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token,applicationID:1, paymentMethod:'2', value: Number(state.value), transID: props.albtelecomMobileSliceState.transactionId}, baseUrlKey:'services', endpoint:'startCreditCardPayment'}))
            //     : dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, transID: props.albtelecomMobileSliceState.transactionId, service: props.utilityName}, baseUrlKey:'services', endpoint:'Eagle/ConfirmTransaction'}))

            dispatch(setIsTransactionSuccessfullyStarted(false))


        }
        if(props.albtelecomMobileSliceState.isTransactionSuccessfullyCompleted){
            dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, phone: props.albtelecomMobileSliceState.phone}, baseUrlKey:'services', endpoint:'Eagle/GetEagleOffers'}))
            dispatch(setIsTransactionSuccessfullyCompleted(false))
        }
        },[props.albtelecomMobileSliceState.isTransactionSuccessfullyStarted, props.albtelecomMobileSliceState.isTransactionSuccessfullyCompleted])

    const useStyles = makeStyles({
        mainGrid:{
            padding: '5%',
            paddingTop: '3%'
        },
        utilityName:{
            color:props.utilityInfo.Color,
            fontSize:'1.5rem',
            fontFamily:'GerberaBold',
            paddingTop:'3%',
            paddingLeft:'2%'
        },
        headerBox:{
            backgroundColor: colors.cyan,
            borderRadius:'100%',
            width:'70px',
            height:'70px'
        },
        fieldTitle:{
            color:colors.darkBlue,
            fontSize:'1.2rem',
            fontFamily:'GerberaBold',
            textAlign:'left'
        },
        button:{
            width:'100%',
            color:colors.white,
            fontSize:'1rem',
            textTransform:'none',
            background:colors.gradientOrange,
            fontFamily:'GerberaBold'
        },
        buttonGrid:{
            marginTop:150,
            paddingBottom: 5
        },
        image:{
            width:'70%'
        },
        textField:{
            width:'100%'
        }
    })

    const classes = useStyles()

  return (
    <Grid container item className={classes.mainGrid} rowSpacing={3} >
        {
        basicAccountSliceState.shouldBasicAccountPaymentRun 
        ? 
            runBasicAccountPayment(
                    dispatch,
                    basicAccountSliceState.basicAccountPaymentUrl,
                    {request: {token: props.globalDataSliceState.token, transID: props.albtelecomMobileSliceState.transactionId, service: props.utilityName}, baseUrlKey:'services', endpoint:'Eagle/ConfirmTransaction'},
                    {request: {token: props.globalDataSliceState.token, orderId: props.albtelecomMobileSliceState.transactionId}, baseUrlKey:'services', endpoint:'cancelCreditCardPayment'},
                    handleBackButton
                ) 
        :
        <>
        <Grid container item md={2} xs={2} mt={2} ><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
        <Grid container item md={12} xs={12} >
        <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} ><img src={props.utilityInfo.Images.filter(image => image.color === 1 && image.size === 1)[0].imagePath} className={classes.image}/></Grid>
            <Typography className={classes.utilityName} >{props.utilityInfo.PublicName}</Typography>
        </Grid>
        <Grid container item rowSpacing={3}  >
            <Grid item md={12} xs={12}  >
                <Typography className={classes.fieldTitle}>{texts["title-field-number"]}</Typography>
            </Grid>
            <Grid item md={12} xs={12} >
                <TextField onChange={handleTextFieldChange('phone')} value={state.phone} label={texts["placeholder-utility-number"]} color='warning' size='small'  className={classes.textField} />
            </Grid>
            <Grid item md={12} xs={12} >
                <Typography className={classes.fieldTitle}>{texts["title-field-amount"]}</Typography>
            </Grid>
            <Grid item md={12} xs={12} >
                <TextField onChange={handleTextFieldChange('value')} value={state.value} color='warning' size='small' label={texts["placeholder-utility-amount"]} className={classes.textField} />
            </Grid>
            <Grid item md={12} xs={12} className={classes.buttonGrid} >
                <Button disabled={albtelecomMobileSliceState.isLoading ? true : false} onClick={handleSearchButtonClick} className={classes.button} >{texts["title-topup"]}</Button>
            </Grid>
            {props.albtelecomMobileSliceState.isConfirmationDialogOpen && <ConfirmationDialog handleClose={()=>{dispatch(changeConfirmationDialogState())}} isConfirmationDialogOpen={props.albtelecomMobileSliceState.isConfirmationDialogOpen} data={texts["message-confirm-transaction-general"]} handleConfirmationClick={startTransaction}/>}
        </Grid>
        </>   
        }
    </Grid>
  )
}
export default AlbtelecomMobile 